import React from 'react';
import classNames from 'classnames';
import classes from './giveaway-landing-description.scss';
export const GiveawayLandingDescription = ({
  description
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.description, {
      [classes.emptyDescription]: !description
    })
  }, description);
};